"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.32
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFAApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var MFAApi = /** @class */ (function (_super) {
    __extends(MFAApi, _super);
    function MFAApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * There are three scenarios that can be returned. > Scenarios:  * NONE: No users found with that email address  * MFA: At least 1 MFA User found with that email address  * LEGACY: 1 or more Users found with that email address but none are mfaEnabled
     * Check if any existing, non DELETED users exist for an email address.
     */
    MFAApi.prototype.checkEmailRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.checkEmailBody === null || requestParameters.checkEmailBody === undefined) {
                            throw new runtime.RequiredError('checkEmailBody', 'Required parameter requestParameters.checkEmailBody was null or undefined when calling checkEmail.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/check-email",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CheckEmailBodyToJSON(requestParameters.checkEmailBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CheckEmailResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * There are three scenarios that can be returned. > Scenarios:  * NONE: No users found with that email address  * MFA: At least 1 MFA User found with that email address  * LEGACY: 1 or more Users found with that email address but none are mfaEnabled
     * Check if any existing, non DELETED users exist for an email address.
     */
    MFAApi.prototype.checkEmail = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkEmailRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Allow users with the same email and application to use one profile.
     */
    MFAApi.prototype.consolidateProfileRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.consolidateProfileBody === null || requestParameters.consolidateProfileBody === undefined) {
                            throw new runtime.RequiredError('consolidateProfileBody', 'Required parameter requestParameters.consolidateProfileBody was null or undefined when calling consolidateProfile.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/consolidate-profile",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ConsolidateProfileBodyToJSON(requestParameters.consolidateProfileBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ConsolidateProfileResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Allow users with the same email and application to use one profile.
     */
    MFAApi.prototype.consolidateProfile = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.consolidateProfileRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of valid users by email address for a given application. > The valid users to be returned.  * Match email address.  * Not in DELETED status.  * Not WEB_SERVICE users.  * Are associated with the passed application.  * Are not associated with the Save SSA account.  * Do not have the deprecated roles of ENROLLMENT or ONBOARDING
     * Get a list of valid users by email address. Intended for use only by VisAdmin
     */
    MFAApi.prototype.getUsersByEmailRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.getUsersByEmailBody === null || requestParameters.getUsersByEmailBody === undefined) {
                            throw new runtime.RequiredError('getUsersByEmailBody', 'Required parameter requestParameters.getUsersByEmailBody was null or undefined when calling getUsersByEmail.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/get-by-email",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.GetUsersByEmailBodyToJSON(requestParameters.getUsersByEmailBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.GetUsersByEmailResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a list of valid users by email address for a given application. > The valid users to be returned.  * Match email address.  * Not in DELETED status.  * Not WEB_SERVICE users.  * Are associated with the passed application.  * Are not associated with the Save SSA account.  * Do not have the deprecated roles of ENROLLMENT or ONBOARDING
     * Get a list of valid users by email address. Intended for use only by VisAdmin
     */
    MFAApi.prototype.getUsersByEmail = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUsersByEmailRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Called by vis-identity-service as part of the OIDC flow for login.gov.<br> Searches first by loginDotGovId (for individuals who have previosuly logged in), then by emailAddress.<br> If migrationUserId is provided that specific User is \"claimed\" and associated to the shared profile for the individual.<br> Also sets the \"allEmails\" attribute on the shared profile as login.gov is the system of record for email addresses.
     * Find Users associated to an individual\'s login.gov account
     */
    MFAApi.prototype.idpLoginRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.loginIdpBody === null || requestParameters.loginIdpBody === undefined) {
                            throw new runtime.RequiredError('loginIdpBody', 'Required parameter requestParameters.loginIdpBody was null or undefined when calling idpLogin.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/idp-login",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.LoginIdpBodyToJSON(requestParameters.loginIdpBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.LoginIdpResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Called by vis-identity-service as part of the OIDC flow for login.gov.<br> Searches first by loginDotGovId (for individuals who have previosuly logged in), then by emailAddress.<br> If migrationUserId is provided that specific User is \"claimed\" and associated to the shared profile for the individual.<br> Also sets the \"allEmails\" attribute on the shared profile as login.gov is the system of record for email addresses.
     * Find Users associated to an individual\'s login.gov account
     */
    MFAApi.prototype.idpLogin = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.idpLoginRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Manages the status and last_login_date upon selection of a specific user account from the E-Verify/SAVE dashboard.
     * Invoked by vis-identity to access a specific User from the E-Verify/SAVE dashboard.
     */
    MFAApi.prototype.multiUserSelectedRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.multiUserSelectedBody === null || requestParameters.multiUserSelectedBody === undefined) {
                            throw new runtime.RequiredError('multiUserSelectedBody', 'Required parameter requestParameters.multiUserSelectedBody was null or undefined when calling multiUserSelected.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/users/multi-user-selected",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.MultiUserSelectedBodyToJSON(requestParameters.multiUserSelectedBody),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Manages the status and last_login_date upon selection of a specific user account from the E-Verify/SAVE dashboard.
     * Invoked by vis-identity to access a specific User from the E-Verify/SAVE dashboard.
     */
    MFAApi.prototype.multiUserSelected = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.multiUserSelectedRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return MFAApi;
}(runtime.BaseAPI));
exports.MFAApi = MFAApi;
